export const trackEvent = (action, payload, { callback }) => {
  window.gtag('event', action, {
    ...payload,
    event_callback() {
      callback();
    },
  });
};

export const trackShareQuiz = ({ disease, method, url, callback }) => {
  trackEvent(
    'share_quiz',
    {
      disease,
      method,
      link: url,
    },
    { callback },
  );
};
